import React, { useEffect, useState } from 'react';
import { apiClient } from '../lib/api-client';
import { useAuthStore } from '../store/authStore';

export const SsoCallbackPage: React.FC = () => {
  const [error, setError] = useState('');
  const login = useAuthStore((state) => state.login);

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (!code) {
      setError('The AuthorizeMe login response is missing its one-time code.');
      return;
    }

    let cancelled = false;
    apiClient.completeSso(code)
      .then((response) => {
        if (cancelled) return;
        login(response.user, response.token);
        window.location.replace(response.return_to || '/transmission-control');
      })
      .catch((reason: Error) => {
        if (!cancelled) setError(reason.message || 'AuthorizeMe login could not be completed.');
      });
    return () => { cancelled = true; };
  }, [login]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 dark:bg-gray-900">
      <div className="w-full max-w-md rounded-xl bg-white p-8 text-center shadow dark:bg-card">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-4 border-indigo-200 border-t-indigo-600" />
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white">Completing secure sign-in</h1>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">Verifying your AuthorizeMe session and LogLimit access.</p>
        {error && (
          <div className="mt-5 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700 dark:border-red-500/30 dark:bg-red-900/20 dark:text-red-400">
            {error} <a className="font-medium underline" href="/login">Return to sign in</a>
          </div>
        )}
      </div>
    </div>
  );
};
